module.exports = __webpack_public_path__ + "static/media/Emerald Coast Association of Realtors Logo.15cee2d2.png";